export default {"src":"/_next/static/media/cassava.55d31aae.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};